import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppNotification } from '@feature/utils';

import { MobilityForm } from './MobilityForm';
import { useMobilityUpdate } from './model/MobilityQuery';
import {
  MobilitySchema,
  defaultMobilityValues,
  mobilitySchema,
  toMobilityRequest,
  toMobilitySchema,
} from './model/MobilitySchema';
import { Mobility } from './model/MobilityTypes';

interface MobilityEditProps {
  mobility: Mobility;
}

export function MobilityEdit({ mobility }: MobilityEditProps) {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useMobilityUpdate(mobility.id);

  const notification = useAppNotification();
  const navigate = useNavigate();

  const onSubmit = (values: MobilitySchema) =>
    mutate(toMobilityRequest(values), {
      onError: notification.error,
      onSuccess: notification.success,
    });

  const values = useMemo(() => toMobilitySchema(mobility), [mobility]);

  return (
    <MobilityForm
      title={t('mobilities.form.title.edit')}
      schema={mobilitySchema}
      defaultValues={defaultMobilityValues}
      values={values}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
